import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

export const LanguageSwitcher: FC = () => {
  const { i18n } = useTranslation();
  const isZh = i18n.language.startsWith('zh');

  const toggle = (): void => {
    void i18n.changeLanguage(isZh ? 'en' : 'zh-CN');
  };

  return (
    <button type="button" onClick={toggle} className={styles.root} aria-label="Switch language">
      <span className={isZh ? styles.active : styles.inactive}>中</span>
      <span className={styles.divider} aria-hidden="true">
        /
      </span>
      <span className={!isZh ? styles.active : styles.inactive}>EN</span>
    </button>
  );
};

LanguageSwitcher.displayName = 'LanguageSwitcher';
